import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { LOCATION_SERVER } from '../../../constants/LOCATION'
import { ReportInputFields, ReportInputRequest } from '../types/report.input.types'
import { WeeklyReportPageType } from '../types/report.page.types'
import { useTokenReport } from './useTokenReport'

type ReportDetailsData = {
  input: ReportInputRequest
  page: WeeklyReportPageType
  fields: ReportInputFields
  events: Record<string, number>
}
type ReportResponseType = {
  report: {
    id: string
    user_id: string
    token: string
    data: ReportDetailsData //json
    created: string
    disable_sales?: boolean
    sent_to_user_time?: string
  }
  data: ReportDetailsData
}

const requestInputReport = async (token: string | undefined): Promise<ReportResponseType> => {
  return axios.get(`${LOCATION_SERVER}/reports/data/${token}`).then((res) => res.data)
}

export const useReportInputData = () => {
  const { token } = useTokenReport()
  return useQuery([`token-report-${token}`], () => requestInputReport(token))
}
